// constants.js
export const FILE_TYPE_ALLOWED = "image/png, image/jpeg, video/mp4, audio/webm";
export const FILE_TYPE_VIDEO = "(mp4|webm)";
export const FILE_TYPE_VIDEO_ALLOWED = "video/mp4, video/webm";
export const MAX_FILE_SIZE_MB = 5;